import ResourceList from "components/cms/ResourceList";
import useResourceList from "hooks/useResourceList";
import { deleteCustomerCase, listCustomerCases } from "api/customercase";
import { enText } from "utils/cms";

export default function CasesPage() {
  const list = useResourceList({
    list: listCustomerCases,
    remove: deleteCustomerCase,
    confirm: (item) => `Delete case “${item.client || item.slug}”? This cannot be undone.`,
  });

  return (
    <ResourceList
      title="Customer cases"
      description="Every case uses the same case-study template"
      createHref="/admin/cases/new"
      createLabel="New case"
      emptyText="No cases yet. Create one to show it on /resources/cases."
      items={list.items}
      total={list.total}
      loading={list.loading}
      error={list.error}
      toast={list.toast}
      onCloseToast={() => list.setToast(null)}
      deletingId={list.deletingId}
      onDelete={list.onDelete}
      editHref={(item) => `/admin/cases/${item._id}`}
      columns={[
        { key: "client", label: "Client" },
        { key: "title", label: "Title", render: (item) => enText(item.title) || "—" },
        { key: "slug", label: "Slug" },
        {
          key: "industry",
          label: "Industry",
          render: (item) => enText(item.industryLabel) || item.industrySlug || "—",
        },
        { key: "year", label: "Year" },
      ]}
    />
  );
}
